import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store/store';
import { setBannerVisibility } from '../store/campaignSlice';

const CORTEXIQ_URL = 'https://closeiq.sellersynapse.com/';

const Banner: React.FC = () => {
  const dispatch = useDispatch();
  const isVisible = useSelector((state: RootState) => state.campaign.isBannerVisible);

  const handleCloseBanner = () => {
    dispatch(setBannerVisibility(false));
  };

  if (!isVisible) return null;

  return (
    <div className="relative bg-gradient-to-r from-[#c501ee] via-[#6b57ff] to-[#1e9ef8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-center">
        <div className="flex items-center flex-wrap gap-3">
          <span className="text-sm sm:text-base font-medium text-white">
            Turn your search term reports into instant PPC audits. CloseIQ helps Amazon agencies close more deals.
          </span>
          <a
            href={CORTEXIQ_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-blue-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-blue-700 focus:ring-white"
          >
            Learn More
          </a>
        </div>
        <button
          onClick={handleCloseBanner}
          className="absolute right-4 flex-shrink-0 p-1 text-white hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-white"
          aria-label="Close banner"
        >
          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Banner;
